import { useQuery } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCall";

export const useAddressAutoComplete = (userRequest, enabled = true) => {
  const { params, data } = userRequest;
  const request = {
    method: "get",
    url: "address/autocomplete",
    params: params,
    data: data,
  };
  return useQuery({
    queryKey: ["addressAutoComplete", params],
    enabled: enabled,
    queryFn: () => callApi(request),
  });
};
